<template>
    <div class="mainWrapper">
        <div class="navbar-header">
            <a class="navbar-brand" href="#"><small>Powered by&nbsp;<img alt="Brand" class="mainLogo" :src="require('@/assets/img/CIC.png')" height="38" /></small></a>
        </div>
    </div>
    <div class="container">
        <div class="success-left-section">
            <div class="asideBody">
                <h2 v-if="isGovernmentMilitaryTermination">Thank You for Your Time</h2>
                <h2 v-else>Stay Safe, See World!</h2>
                
                <h4 v-if="isGovernmentMilitaryTermination">
                    We appreciate your interest and thank you for your time.
                </h4>
                <h4 v-else>
                    Better Feedback, Smoother Journeys ! Your Input Fuels Our Journey to Excellence.
                </h4>
                
                <div class="col-sm-12 text-center hideElement">
                    <img :src="require('@/assets/img/asideImage/25.gif')" style="width: 100%;">
                </div>
            </div>
            <div class="asideFoot" v-if="!isGovernmentMilitaryTermination">
                <small>Share your experience and encourage others to join!</small><br>
                <div class="">
                    <a class="btn fbBG"><i class="fab fa-facebook-square"></i></a>
                    <a class="btn InstaBG"><i class="fab fa-instagram"></i></a>
                    <a class="btn xBG"><i class="fab fa-twitter"></i></a>
                    <a class="btn waBG"><i class="fab fa-whatsapp"></i></a>
                </div>
            </div>
            <div class="asideFoot" v-else>
                <small>Thank you for visiting our survey.</small>
            </div>
        </div>
        <div class="success-right-section" style="height: calc(100vh - 101px);padding: 30px;overflow-y: auto;">
            <img alt="Brand" class="mainLogo" :src="require('@/assets/img/asideImage/25.gif')" style="height: 320px;" />
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
    name: 'SurveyEndPage',
    setup() {
        const isGovernmentMilitaryTermination = ref(false);
        
        onMounted(() => {
            // Check if this is a Government/Military termination
            const terminationReason = localStorage.getItem('surveyTerminationReason');
            if (terminationReason === 'government-military') {
                isGovernmentMilitaryTermination.value = true;
                
                // Clear the termination reason after showing the message
                setTimeout(() => {
                    localStorage.removeItem('surveyTerminationReason');
                    localStorage.removeItem('surveyTerminationMessage');
                }, 1000);
            }
        });
        
        return {
            isGovernmentMilitaryTermination
        };
    }
};
</script>